/**
 * Constants for panel source selection and branch hierarchy
 * Shared across ModalCreateOrderContainer, BranchHierarchyTree, and related modules
 */

export const REGGORA_PANEL_ID = 'reggoraPanel'

export const PANEL_SOURCE = {
  BRANCH: 'branch',
  OUR_PANEL: 'ourPanel',
  PREFERRED: 'preferred',
  REGGORA_PANEL: 'reggoraPanel',
}

export const REGGORA_NETWORK_NAME = 'Reggora Network'

export const LENDER_PANEL_KEY_PREFIX = 'lender-panel-'

/**
 * Hierarchy types based on backend data format:
 * - BRANCH: Non-AMP users, uses branch_id field, aggregates with branch_ids
 * - PREFERRED_PANEL: AMP users, uses id field, aggregates with preferred_panel_ids
 */
export const HIERARCHY_TYPE = {
  BRANCH: 'branch',
  PREFERRED_PANEL: 'preferred_panel',
}

/**
 * Tooltip messages for panel source hierarchy
 * Provides context-aware messaging based on hierarchy type
 */
export const PANEL_SOURCE_TOOLTIPS = {
  [HIERARCHY_TYPE.BRANCH]: {
    panelistCount: 'The numbers shown next to each branch indicate the amount of eligible panelists in that branch.',
    disabledItem: 'This branch does not have any eligible panelists for this order',
  },
  [HIERARCHY_TYPE.PREFERRED_PANEL]: {
    panelistCount: 'The numbers shown next to each preferred panel indicate the amount of eligible panelists in that preferred panel.',
    disabledItem: 'This panel does not have any eligible panelists for this order',
  },
}

/**
 * Gets the appropriate tooltip message based on hierarchy type
 * @param {string} hierarchyType - HIERARCHY_TYPE.BRANCH or HIERARCHY_TYPE.PREFERRED_PANEL
 * @param {string} tooltipKey - 'panelistCount' or 'disabledItem'
 * @returns {string} The tooltip message
 */
export const getPanelSourceTooltip = (hierarchyType, tooltipKey) => {
  const type = hierarchyType || HIERARCHY_TYPE.BRANCH
  return PANEL_SOURCE_TOOLTIPS[type]?.[tooltipKey] || PANEL_SOURCE_TOOLTIPS[HIERARCHY_TYPE.BRANCH][tooltipKey]
}
